import type {BgColor} from '../../lib/lvs-foni'
import {LVS_COLORS} from '../../lib/lvs-colors'
import {MonoLabel} from '../ui/mono-label'
import {UnderlineSelect} from '../ui/underline-field'
import {lvsRef} from '../../lib/utils'

const BG_LABELS: Readonly<Record<BgColor, string>> = {
    white: 'Balts',
    blue: 'Zils'
}

const DEFAULT_BG_COLORS: readonly BgColor[] = ['white', 'blue']

export interface FoniBgControlsProps {
    readonly bgColor: BgColor
    readonly onBgColorChange: (c: BgColor) => void
    readonly strike: boolean
    readonly onStrikeChange: (s: boolean) => void
    /** Restrict the bg-color options. Defaults to [white, blue]. */
    readonly allowBgColors?: readonly BgColor[]
    /** Hide the strike toggle entirely. Defaults to true (show). */
    readonly showStrike?: boolean
}

/**
 * Controlled bg color + strike toggles. Canonical UI for foni background
 * styling. Used by FoniPage directly and by the konstruktors wizard's
 * BackgroundStep (which can hide the strike toggle per sign-def).
 */
export function FoniBgControls({
    bgColor,
    onBgColorChange,
    strike,
    onStrikeChange,
    allowBgColors = DEFAULT_BG_COLORS,
    showStrike = true
}: FoniBgControlsProps) {
    return (
        <div className='flex flex-wrap gap-x-8 gap-y-5 items-end'>
            <div className='flex flex-col gap-1.5'>
                <MonoLabel>Pamatkrāsa</MonoLabel>
                <UnderlineSelect
                    value={bgColor}
                    onChange={e => onBgColorChange(e.target.value as BgColor)}
                >
                    {allowBgColors.map(c => (
                        <option
                            key={c}
                            value={c}
                        >
                            {BG_LABELS[c]}
                        </option>
                    ))}
                </UnderlineSelect>
            </div>

            {showStrike && (
                <div className='flex flex-col gap-1.5'>
                    <MonoLabel>Šķērssvītra ({lvsRef('9.20', 'clause')})</MonoLabel>
                    <label className='flex items-center gap-2 cursor-pointer py-1.5'>
                        <input
                            type='checkbox'
                            checked={strike}
                            onChange={e => onStrikeChange(e.target.checked)}
                            className='cursor-pointer'
                            style={{accentColor: LVS_COLORS.red.hex}}
                        />
                        <span className='font-mono text-sm text-foreground'>Sarkanā svītra</span>
                    </label>
                </div>
            )}
        </div>
    )
}
